const metodoDePago = {
    TARJETA: 'tarjeta',
    MONETARIO: 'monetario'
}

export default metodoDePago;